import React from "react";
import QuoteFlow from "./QuoteFlow";
import QuoteDisabled from "./QuoteDisabled";

const QuoteSelector = () => {
  const quoteFlowEnabled = !window.appConfig?.direct_quotes_disabled;

  if (quoteFlowEnabled) {
    return <QuoteFlow />;
  }

  return <QuoteDisabled />;
};

export default QuoteSelector;
